import { render, staticRenderFns } from "./EstadisticasPage.vue?vue&type=template&id=20ff756c"
import script from "./EstadisticasPage.js?vue&type=script&lang=js&external"
export * from "./EstadisticasPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports